<template>
  <div class="project-summary-container">
    <div v-if="loading" class="loading-box">
      <Spin :pointNum="8" :translateX="25" background="var(--base-primary-bgColor)" />
    </div>
    <div class="all-summary-box" v-if="!loading">
      <div class="project-summary-box">
        <div class="summary-item" :class="index < 5 ? 'summary-item-top' : ''"
          v-for="(item, index) in projectSummaryList" :key="index">
          <div class="name-box">
            <div class="icon-box" :class="`icon-box${index}`">
              <icon-svg size="12" :icon-class="item.icon" class="icon" />
            </div>
            <div class="name">{{ item.name }}</div>
            <!-- <div :class="`icon-top icon${index + 1}`">
              <icon-svg
                v-if="item.count.toString().length > 6"
                size="120"
                icon-class="icon-kapianzhuangshitongjizhu-01"
                class="name-box-icon"
                :isGradientVisible="true"
                :gradientId="`gradient${index + 1}`" />
            </div> -->
          </div>
          <div class="summary-box">
            <div class="count-box">
              <span class="count">{{ item.count }}</span>
              <span class="unit">{{ item.unit }}</span>
            </div>
            <!-- <div :class="`icon-box icon${index + 1}`">
              <icon-svg
                v-if="item.count.toString().length <= 6"
                size="120"
                icon-class="icon-kapianzhuangshitongjizhu-01"
                class="icon"
                :isGradientVisible="true"
                :gradientId="`gradient${index + 1}`" />
            </div> -->
          </div>
        </div>
      </div>
      <div class="model-summary-box">
        <div class="dataset-count-box">
          <div class="symbol-box"></div>
          <div class="summary-box">
            <div class="summary-item" :class="index < 4 ? 'summary-item-top' : ''"
              v-for="(item, index) in dataSetSummaryList" :key="index">
              <div class="name">{{ item.label }}</div>
              <div class="count">{{ item.value }}个</div>
            </div>
          </div>
        </div>
        <div class="split-area"></div>
        <div class="model-count-box">
          <div class="symbol-box"></div>
          <div class="summary-box">
            <div class="summary-item" :class="index < 2 ? 'summary-item-top' : ''"
              v-for="(item, index) in modelSummaryList" :key="index">
              <div class="name">{{ item.name }}</div>
              <div class="count">{{ item.count }}{{ item.unit }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dataset-summary-box">
      <div class="common-tabs-box">
        <el-tabs class="tab-page-primary" v-model="activeTab">
          <el-tab-pane label="模型统计" name="bim-summary">
            <div class="tabs-content">
              <div class="common-table-box">
                <el-table class="publish-table" highlight-selection-row ref="modelTable"
                  :header-row-class-name="customHeaderK" v-if="activeTab === 'bim-summary'" v-loading="tableLoading"
                  :data="modelStatistic" height="100%">
                  <el-table-column label="序号" type="index" width="75">
                  </el-table-column>
                  <el-table-column label="数据集名称" width="400">
                    <template v-slot="{ row }">
                      <span class="text-overflow" :title="row.dataSetName">
                        {{ row.dataSetName }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="文件数量" property="pakNum" />
                  <el-table-column label="构件数量" property="elemNum" />
                  <el-table-column label="构件属性数量" min-width="110px" property="elemParaNum" />
                  <el-table-column label="目录树节点数量" min-width="126px" property="treeNodeNum" />
                  <el-table-column label="目录树属性数量" min-width="110px" property="treeNodeParaNum" width="160" />
                  <el-table-column label="三角面数量" min-width="110">
                    <template v-slot="{ row }">
                      <span>
                        {{ row.faceNum !== -1 ? row.faceNum : '--' }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="源文件大小" min-width="110px">
                    <template v-slot="{ row }">
                      <span>
                        {{ getFileSize(row.sourceFileTotalSize) }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="pak文件大小" min-width="110px">
                    <template v-slot="{ row }">
                      <span>
                        {{ getFileSize(row.pakFileTotalSize) }}
                      </span>
                    </template>
                  </el-table-column>
                  <template slot="empty">
                    <div class="common-empty-box">
                      <bj-empty :image="require('@/assets/img/no-data.png')" class="empty-page">
                        <template slot="description">
                          <div class="empty-text">抱歉，没有找到相关内容</div>
                        </template>
                      </bj-empty>
                    </div>
                  </template>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="近期变更统计" name="change-summary">
            <div class="tabs-content">
              <div class="common-table-box">
                <el-table class="publish-table" v-if="activeTab === 'change-summary'" v-loading="tableLoading"
                  :data="logs" height="100%">
                  <el-table-column label="序号" type="index" width="75">
                  </el-table-column>
                  <el-table-column label="数据集名称" width="320">
                    <template v-slot="{ row }">
                      <span class="text-overflow" :title="row.dataSetName">{{ row.dataSetName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="数据类型" property="dataType"></el-table-column>
                  <el-table-column label="数据大小">
                    <template v-slot="{ row }">
                      <span>{{
                        `${formatFileSize(row.fileTotalSize).fileSize}${formatFileSize(row.fileTotalSize).unit
                        }`
                      }}</span>
                    </template></el-table-column>
                  <el-table-column label="开始时间" width="180">
                    <template v-slot="{ row }">
                      <span>{{ formatTime(row.startTime) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="结束时间" width="180">
                    <template v-slot="{ row }">
                      <span>{{ formatTime(row.endTime) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="耗时" property="convertDuration"></el-table-column>
                  <el-table-column label="状态" property="status"></el-table-column>
                  <el-table-column label="操作人" property="userName"></el-table-column>
                  <el-table-column label="操作次数">
                    <template v-slot="{ row }">
                      <span class="text-overflow" :title="row.version">{{ row.version }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="100">
                    <template v-slot="{ row }">
                      <div class="common-button-box operation-cell">
                        <el-button v-if="
                          row.dataType === 'bim' ||
                          row.convertTyp === '修改元素'
                        " @click="viewDetail(row)" type="text" size="small">
                          详细信息
                        </el-button>
                        <span v-else>--</span>
                      </div>
                    </template>
                  </el-table-column>
                  <template slot="empty">
                    <div class="common-empty-box">
                      <bj-empty :image="require('@/assets/img/no-data.png')" class="empty-page">
                        <template slot="description">
                          <div class="empty-text">抱歉，没有找到相关内容</div>
                        </template>
                      </bj-empty>
                    </div>
                  </template>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <DragDialog title="数据集变更详情" :width="800" :visible.sync="visible" :footerBtn="[]" :cancel="closeDialog">
      <div class="common-table-box dialog-content-box">
        <el-table class="publish-table" :data="nodeItems" height="100%">
          <el-table-column label="序号" type="index" width="100">
          </el-table-column>
          <el-table-column label="名称" width="360">
            <template v-slot="{ row }">
              <span class="text-overflow" :title="row.displayName">
                {{ row.displayName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="变更方式" property="actionName">
            <template v-slot="{ row }">
              <span>{{ formatActionName(row.actionName) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </DragDialog>
  </div>
</template>

<script>
import Spin from '@/components/Spin.vue'
import DragDialog from '@/components/CustomDragDialog.vue'

import { formatTime, formatFileSize } from '@/utils/generalMethods'

import {
  singleProjectSummary,
  getProjectSummary,
  getProjectChangeLog,
  getProjectChangeLogDetail
} from '@/service/interface'

export default {
  data() {
    return {
      loading: false,
      projectSummaryList: [],
      dataSetSummaryList: [],
      modelSummaryList: [],
      activeTab: 'bim-summary',
      tableLoading: false,
      modelStatistic: [],
      logs: [],
      visible: false,
      nodeItems: [],
      customHeaderK: '',
      totalFaceNum: 0
    }
  },
  components: { Spin, DragDialog },
  created() {
    this.initProjectSummary()
    this.initDatasetSummary()
    this.initProjectChangeLog()
  },
  mounted() {
    const currentBody = this.$refs.modelTable.bodyWrapper
    currentBody.addEventListener('scroll', ev => {
      const scrollTop = ev.target.scrollTop
      this.customHeaderK = scrollTop > 10 ? 'darkHeader' : ''
    })
  },
  methods: {
    initProjectSummary() {
      this.loading = true
      const mapArray = [
        { name: '建筑信息模型', label: 'BIM模型', value: 0 },
        { name: '遥感影像', label: '遥感影像', value: 0 },
        { name: '地图瓦片服务', label: 'WMTS地图服务', value: 0 },
        { name: '倾斜摄影', label: '倾斜摄影', value: 0 },
        { name: '360全景图', label: '360全景', value: 0 },
        { name: '点云', label: '点云', value: 0 },
        { name: '二维图纸', label: '二维图纸', value: 0 },
        { name: '矢量数据', label: '矢量数据', value: 0 }
      ]

      let projectId = this.$route.params.projId
      singleProjectSummary(projectId).then(response => {
        if (response.isSuccess) {
          let summaryInfo = response.data
          let projectSummaryList = []
          projectSummaryList.push({
            name: '文件数量',
            count: summaryInfo.filesCount,
            unit: '个',
            icon: 'ic-wenjianshuliang'
          })
          projectSummaryList.push({
            name: '数据集数量',
            count: summaryInfo.dataSetsCount,
            unit: '个',
            icon: 'ic-shujujishuliang'
          })
          let fileSize = this.formatFileSize(summaryInfo.filesAllSize)
          projectSummaryList.push({
            name: '文件大小',
            count: fileSize.fileSize !== '--' ? fileSize.fileSize : 0,
            unit: fileSize.unit ? fileSize.unit : 'MB',
            icon: 'ic-wenjiandaxiao'
          })
          projectSummaryList.push({
            name: '场景数量',
            count: summaryInfo.scenesCount,
            unit: '个',
            icon: 'ic-changjingshuliang'
          })
          projectSummaryList.push({
            name: '三角面数量',
            count:
              Number(this.totalFaceNum) >= 0 ? Number(this.totalFaceNum) : 0,
            unit: '个',
            icon: 'icon-sanjiaomian'
          })
          this.projectSummaryList = projectSummaryList

          let dataSetSummary = summaryInfo.dataSetTypeSumary
          mapArray.forEach(item => {
            let find = dataSetSummary.find(el => el.dataSetType === item.name)
            item.value = find.dataSetCount
          })
          this.dataSetSummaryList = mapArray

          this.loading = false
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    initDatasetSummary() {
      let projId = this.$route.params.projId
      let params = { projId }
      this.tableLoading = true
      getProjectSummary(params).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let modelSummaryList = []
          modelSummaryList.push({
            name: '构件总数',
            count: data.totalElemNum,
            unit: '个',
            icon: 'ic-goujianzongshu1'
          })
          modelSummaryList.push({
            name: '属性总数',
            count: data.totalElemParaNum,
            unit: '个',
            icon: 'ic-shuxingzongshu1'
          })
          modelSummaryList.push({
            name: '目录树节点数',
            count: data.totalTreeNodeNum,
            unit: '个',
            icon: 'ic-mulushujiedianshu1'
          })
          this.totalFaceNum = data?.totalFaceNum ?? 0
          modelSummaryList.push({
            name: '目录树属性数',
            count: data.totalTreeNodeParaNum,
            unit: '个',
            icon: 'ic-mulushushuxingshu1'
          })
          this.modelSummaryList = modelSummaryList
          this.modelStatistic = data.modelStatistic

          this.tableLoading = false
        }
      })
    },
    initProjectChangeLog() {
      let projId = this.$route.params.projId
      let params = { projId, startTime: '', endTime: '' }
      getProjectChangeLog(params).then(response => {
        if (response.isSuccess) {
          this.logs = response.data
        }
      })
    },
    viewDetail(changeInfo) {
      let params = {
        versionId: changeInfo.versionId
      }
      getProjectChangeLogDetail(params).then(response => {
        if (response.isSuccess) {
          let detailInfo = response.data
          this.nodeItems = detailInfo.nodeItems

          this.visible = true
        }
      })
    },
    closeDialog() {
      this.visible = false
    },
    formatActionName(actionName) {
      return actionName.replace('转换', '')
    },
    getFileSize(fileSize) {
      let fileSizeStr = '--'
      if (fileSize && fileSize > 0) {
        let size = formatFileSize(fileSize).fileSize
        let unit = formatFileSize(fileSize).unit
        fileSizeStr = `${size}${unit}`
      }
      return fileSizeStr
    },
    formatFileSize,
    formatTime
  }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/publishSearch.less');
@import url('@/assets/css/pageStyle.less');

.project-summary-container {
  flex-grow: 1;
  padding: 0 16px;
  margin-bottom: 16px;
  // border-radius: 16px;
  // overflow: hidden;

  .loading-box {
    position: relative;
    height: 320px;
    border-radius: 16px;
    background: var(--page-loading-bgColor);
  }

  .all-summary-box {
    width: 100%;
    padding: 16px;
    border-radius: 16px;
    background: var(--projectSummary-top-bgColor);
    box-shadow: var(--page-shadow-bgColor);

    .project-summary-box {
      display: grid;
      grid-template-columns: repeat(5, 1fr);

      .summary-item {
        height: 132px;
        margin-left: 16px;
        padding: 16px;
        padding-top: 24px;
        padding-left: 24px;
        border-radius: 16px;
        background: var(--projectSummary-card-bgColor);
        container: summary-container / inline-size;

        &:first-child {
          margin-left: 0px;
        }

        .icon1 {
          /deep/ .svg-icon {
            fill: url('#gradient1');

            #gradient1 {
              stop:first-child {
                stop-color: var(--base-primary-color);
                stop-opacity: 1;
              }

              stop:last-child {
                stop-color: var(--base-light-color12);
                stop-opacity: 0.5;
              }
            }
          }
        }

        .icon2 {
          /deep/ .svg-icon {
            fill: url('#gradient2');

            #gradient2 {
              stop:first-child {
                stop-color: var(--base-light-color13);
                stop-opacity: 1;
              }

              stop:last-child {
                stop-color: var(--base-light-color14);
                stop-opacity: 0.5;
              }
            }
          }
        }

        .icon3 {
          /deep/ .svg-icon {
            fill: url('#gradient3');

            #gradient3 {
              stop:first-child {
                stop-color: var(--base-light-color15);
                stop-opacity: 1;
              }

              stop:last-child {
                stop-color: var(--base-light-color16);
                stop-opacity: 0.5;
              }
            }
          }
        }

        .icon4 {
          /deep/ .svg-icon {
            fill: url('#gradient4');

            #gradient4 {
              stop:first-child {
                stop-color: var(--base-light-color17);
                stop-opacity: 1;
              }

              stop:last-child {
                stop-color: #5cffcd;
                stop-opacity: 1;
              }
            }
          }
        }

        .icon3 {
          /deep/ .svg-icon {
            fill: url('#gradient3');

            #gradient5 {
              stop:first-child {
                stop-color: var(--base-bg-light-color65);
                stop-opacity: 1;
              }

              stop:last-child {
                stop-color: var(--base-bg-light-color66);
                stop-opacity: 0.5;
              }
            }
          }

          .icon5 {
            /deep/ .svg-icon {
              fill: url('#gradient5');

              #gradient5 {
                stop:first-child {
                  stop-color: #6742ff;
                  stop-opacity: 1;
                }

                stop:last-child {
                  stop-color: #a48eff;
                  stop-opacity: 1;
                }
              }
            }
          }
        }

        .name-box {
          display: flex;

          .icon-top {
            height: 30px;
            position: relative;
            flex: 1;
          }

          .name-box-icon {
            position: absolute;
            top: -48px;
            right: 0;
          }

          .icon-box {
            display: flex;
            align-items: center;
            width: 30px;
            height: 30px;
            padding: 5px;
            background: var(--base-bg-light-color59);
            border-radius: 50%;

            .icon {
              margin: 0px auto;
              font-size: 14px;
            }
          }

          .icon-box1 {
            background: var(--base-bg-light-color60);
          }

          .icon-box2 {
            background: var(--base-bg-light-color61);
          }

          .icon-box3 {
            background: var(--base-bg-light-color62);
          }

          .icon-box4 {
            background: var(--base-bg-light-color67);

            .icon {
              color: var(--aside-bg-color);
            }
          }

          .name {
            margin-left: 10px;
            line-height: 30px;
            font-size: 18px;
            color: var(--projectSummary-text-color);
          }
        }

        .summary-box {
          display: flex;
          justify-content: space-between;
          margin-top: 14px;
          padding-right: 8px;

          .count-box {
            letter-spacing: 2px;

            .count {
              margin-top: 10px;
              // font-size: 32px;
              color: var(--projectSummary-text-color);
              font-weight: bold;
            }

            .unit {
              font-size: 20px;
              color: var(--projectSummary-text-unit-color);
              font-weight: 600;
            }
          }

          .icon-box {
            font-size: 100px;
            margin-top: -38px;
          }
        }
      }
    }

    .model-summary-box {
      display: flex;
      font-size: 12px;
      flex-wrap: nowrap;
      margin-top: 16px;

      .dataset-count-box {
        display: flex;
        flex: 1;
        padding-right: 14px;
        border-radius: 16px;
        background: var(--projectSummary-card-bgColor);
        box-shadow: var(--projectSummary-card-shadow-color);

        .symbol-box {
          display: flex;
          margin: auto 0px;
          width: 15px;
          height: 80px;
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
          border-left: 10px solid var(--base-primary-bgColor);
          border-right: 0px solid transparent;
        }

        .summary-box {
          flex-grow: 1;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          padding: 16px 0px;

          .summary-item-top {
            margin-bottom: 8px;
          }

          .summary-item {
            display: flex;
            height: 44px;
            line-height: 44px;
            text-align: left;
            background: var(--projectSummary-item-card-bgColor);
            border-radius: 8px;
            margin-right: 8px;

            .name {
              font-size: 12px;
              font-weight: 400;
              margin-left: 8px;
              color: var(--projectSummary-item-text-colorLeft);
            }

            .count {
              font-size: 12px;
              font-weight: bold;
              color: var(--projectSummary-item-text-colorRight);
              flex-grow: 1;
              text-align: right;
              margin-right: 8px;
            }
          }
        }
      }

      .split-area {
        width: 15px;
      }

      .model-count-box {
        display: flex;
        flex: 1;
        border-radius: 16px;
        background: var(--projectSummary-card-bgColor);
        box-shadow: var(--projectSummary-card-shadow-color);

        .symbol-box {
          display: flex;
          margin: auto 0px;
          width: 15px;
          height: 80px;
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
          border-left: 10px solid var(--base-bg-light-color63);
          border-right: 0px solid transparent;
        }

        .summary-box {
          display: grid;
          flex-grow: 1;
          grid-template-columns: repeat(2, 1fr);
          padding: 16px 0px;

          .summary-item-top {
            margin-bottom: 8px;
          }

          .summary-item {
            display: flex;
            height: 44px;
            line-height: 44px;
            text-align: left;
            background: var(--projectSummary-item-card-bgColor);
            border-radius: 8px;
            margin-right: 8px;

            .name {
              font-size: 12px;
              font-weight: 400;
              margin-left: 8px;
              color: var(--projectSummary-item-text-colorLeft);
            }

            .count {
              font-size: 12px;
              font-weight: bold;
              color: var(--projectSummary-item-text-colorRight);
              flex-grow: 1;
              text-align: right;
              margin-right: 8px;
            }
          }
        }
      }
    }
  }

  @container summary-container (max-width:229px) {
    .summary-box {
      .count {
        font-size: 20px;
      }
    }
  }

  @container summary-container (min-width:230px) {
    .summary-box {
      .count {
        font-size: 21px;
      }
    }
  }

  @container summary-container (min-width:235px) {
    .summary-box {
      .count {
        font-size: 22px;
      }
    }
  }

  @container summary-container (min-width:240px) {
    .summary-box {
      .count {
        font-size: 24px;
      }
    }
  }

  @container summary-container (min-width:245px) {
    .summary-box {
      .count {
        font-size: 26px;
      }
    }
  }

  @container summary-container (min-width:250px) {
    .summary-box {
      .count {
        font-size: 28px;
      }
    }
  }

  @container summary-container (min-width:255px) {
    .summary-box {
      .count {
        font-size: 30px;
      }
    }
  }

  @container summary-container (min-width:260px) {
    .summary-box {
      .count {
        font-size: 32px;
      }
    }
  }

  .dataset-summary-box {
    width: 100%;
    height: calc(100% - 330px);
    margin-top: 16px;
    border-radius: 16px;
    background-color: var(--projectSummary-bottom-bgColor);

    .common-tabs-box {
      height: 100%;

      .tab-page-primary {
        :deep(.el-tabs__header) {
          padding: 0 16px;
          padding-top: 5px;
        }
      }

      .tabs-content {
        height: 100%;
        padding: 10px 20px;
      }

      /deep/ .el-tabs {
        height: 100%;

        .el-tabs__item:hover {
          color: var(--base-primary-bgColor);
        }

        .is-active {
          color: var(--base-primary-bgColor);
        }

        .el-tabs__active-bar {
          background-color: var(--base-primary-bgColor);
        }

        .el-tabs__nav-wrap::after {
          display: none;
        }

        .el-tabs__content {
          height: calc(100% - 44px);

          .el-tab-pane {
            height: 100%;
          }
        }
      }

      .common-table-box {
        position: relative;
        height: 100%;

        .el-table {
          position: absolute;
        }
      }
    }
  }
}

.dialog-content-box {
  height: 500px;
}
</style>
